import { BrowserRouter, Routes, Route } from "react-router-dom";

// WEBSITE
import Home from "./pages/Home";
import About from "./pages/About";
import NewsPage from "./pages/NewsPage";
import Notice from "./pages/Notice";
import EventPage from "./pages/EventPage";
import Contact from "./pages/Contact";
import LifePage from "./pages/LifePage";
import Gallery from "./pages/Gallery";
import GalleryDetail from "./pages/GalleryDetail";
import Documents from "./pages/Documents";
import ScrollToTop from "./components/ScrollToTop";
import Admission from "./pages/Admission";
import Facility from "./pages/Facility";
import Academics from "./pages/Academics";
import CbseDocuments from "./pages/CbseDocuments";
import MandatoryPublicDisclosure from "./pages/MandatoryPublicDisclosure";
import Parents from "./pages/Parents";
import Infrastructure from "./pages/Infrastructure";
import StudentTc from "./pages/StudentTc";
import StudentTcDetails from "./pages/StudentTcDetails";
import StudentTcSession from "./pages/StudentTcSession";
import VirtualTour from "./pages/VirtualTour";
import HomeVirtualTour from "./pages/HomeVirtualTour";

// ADMIN LOGIN
import AdminLogin from "./pages/AdminLogin";

// ADMIN PAGES
import AdminDashboard from "./pages/AdminDashboard";
import AdminNews from "./admin/AdminNews";
import AdminNotice from "./admin/AdminNotice";
import AdminEvent from "./admin/AdminEvent";
import AdminBirthday from "./admin/AdminBirthday";
import AdminSlider from "./admin/AdminSlider";
import AdminAcademics from "./admin/AdminAcademics";
import AdminGalleryAwards from "./admin/AdminGalleryAwards";
import AdminStudentWork from "./admin/AdminStudentWork";
import AdminChangePassword from "./admin/AdminChangePassword";
import AdminGalleryAlbum from "./admin/AdminGalleryAlbum";
import AdminDocument from "./admin/AdminDocument";
import AdminCbseDocument from "./admin/AdminCbseDocument";
import AdminMPD from "./admin/AdminMPD";
import AdminInfrastructure from "./admin/AdminInfrastructure";
import AdminStudentTc from "./admin/AdminStudentTc";
import AdminTour from "./admin/AdminTour";
import AdminHotspot from "./admin/AdminHotspot";


// PROTECTED ROUTE
import ProtectedRoute from "./components/ProtectedRoute";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />

      <Routes>

        {/* ================= WEBSITE ================= */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/news" element={<NewsPage />} />
        <Route path="/notices/:id" element={<Notice />} />
        <Route path="/events" element={<EventPage />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/life" element={<LifePage />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/gallery/:id" element={<GalleryDetail />} />
        <Route path="/documents" element={<Documents />} />
        <Route path="/admission" element={<Admission />} />
        <Route path="/facilities" element={<Facility />} />
        <Route path="/academics" element={<Academics />} />
        <Route path="/cbse-documents" element={<CbseDocuments />} />
        <Route path="/mandatory-public-disclosure" element={<MandatoryPublicDisclosure />} />
        <Route path="/parents" element={<Parents />} />
        <Route path="/infrastructure" element={<Infrastructure />} />
        <Route path="/student-tc" element={<StudentTc />} />
        <Route path="/student-tc/session/:id" element={<StudentTcSession />} />
        <Route path="/student-tc/class/:id" element={<StudentTcDetails />} />
        <Route path="/virtual-tour" element={<VirtualTour />} />
        <Route path="/home-virtual-tour" element={<HomeVirtualTour />} />

        {/* ================= ADMIN ================= */}

        {/* LOGIN */}
        <Route path="/admin/login" element={<AdminLogin />} />

        {/* PROTECTED ROUTES */}

        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/notice"
          element={
            <ProtectedRoute>
              <AdminNotice />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/event"
          element={
            <ProtectedRoute>
              <AdminEvent />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/birthday"
          element={
            <ProtectedRoute>
              <AdminBirthday />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/slider"
          element={
            <ProtectedRoute>
              <AdminSlider />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/academics"
          element={
            <ProtectedRoute>
              <AdminAcademics />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/galleryAwards"
          element={
            <ProtectedRoute>
              <AdminGalleryAwards />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/student-work"
          element={
            <ProtectedRoute>
              <AdminStudentWork />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/news"
          element={
            <ProtectedRoute>
              <AdminNews />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/password"
          element={
            <ProtectedRoute>
              <AdminChangePassword />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/gallery-album"
          element={
            <ProtectedRoute>
              <AdminGalleryAlbum />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/uploadDocuments"
          element={
            <ProtectedRoute>
              <AdminDocument />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/cbse"
          element={
            <ProtectedRoute>
              <AdminCbseDocument />
            </ProtectedRoute>}
        />

        <Route
          path="/admin/mpd"
          element={
            <ProtectedRoute>
              <AdminMPD />
            </ProtectedRoute>}
        />

        <Route
          path="/admin/infrastructure-doc"
          element={
            <ProtectedRoute>
              <AdminInfrastructure />
            </ProtectedRoute>}
        />

        <Route
          path="/admin/adminstudent-tc"
          element={
            <ProtectedRoute>
              <AdminStudentTc />
            </ProtectedRoute>}
        />

        <Route
          path="/admin/admin-tour"
          element={
            <ProtectedRoute>
              <AdminTour />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/admin-hotspot"
          element={
            <ProtectedRoute>
              <AdminHotspot />
            </ProtectedRoute>
          }
        />


        {/* ================= 404 ================= */}
        <Route path="*" element={<h2>Page Not Found</h2>} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;